module.exports = __webpack_public_path__ + "img/catH.2a77b0fc.svg";